import React, { Component } from 'react';
class AutoTransferJa extends Component {
  render() {
    return (
      <div className="container">
        <div className="row">
          <div className="mgt-30 faq-container">
            <div className="text-center block-title">
              <h2 className="common-title">TRIAM Auto Transfer</h2>
              <span>version: 1.0.1</span>
            </div>
            <div className="content">
              <section className="opening">
                <div className="intro">
                  Auto Transfer機能とは、指定したウォレット内の指定したコインが、設定した数量を超過した際に自動的に他のウォレットへ超過分を転送する機能です。
                  例えば顧客からのコイン支払を受け取るウォレットなどに設定することで、ウォレットの残高の過剰を防ぎ、セキュリティを高めることができます。
                </div>
                <div className="example">
                  <p>例）</p>
                  <ul className="list">
                    <li>
                      <div className="text">
                        <span>①「顧客からのコイン支払を受け取るウォレット」にAuto Transfer機能を設定する</span>
                        <span>指定コイン：RIA</span>
                        <span>指定コイン数量：500,000RIA</span>
                        <span>転送先ウォレット：「顧客支払コイン管理ウォレット」</span>
                      </div>
                    </li>
                    <li>
                      <div className="text">
                        <span>② 顧客から「顧客からのコイン支払を受け取るウォレット」へコイン送信が行われる。「顧客からのコイン支払を受け取るウォレット」内の残高が指定した数量を超えた場合、自動的に過剰分のコインが「顧客支払コイン管理ウォレット」へ転送される。</span>
                      </div>
                    </li>
                  </ul>
                  <div class="img">
                    <img src="/images/auto-transfer-des.png" alt="Auto Transfer Des"/>
                  </div>
                </div>
              </section>
              <hr/>
              <section className="guide">
                <h3><b>Auto Transfer機能の設定手順</b></h3>
                <ul className="step-guide decimal">
                  <li>アカウントにログインし、メニューの「Auto Transfer」ページから設定します。</li>
                  <li>
                    <div className="text">
                      <span>[Setup Auto Transfer］ボタンをクリックします。</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s1.png" alt="Auto Transfer S1"/>
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span><b>Name</b>のフィールドには設定するAuto Transferの説明を入力します。</span>
                      <span><b>Source Wallet</b>にはAuto Transfer機能を設定したいウォレットを選択してください。</span>
                      <span><b>Amount</b>はSource Walletで保有する残高の上限数量を入力します。</span>
                      <span>例）Amountに100,000と設定した場合、そのウォレットで100,000を超えるコインを保有した場合にAuto Transfer機能が作動し、自動的に超過分が指定のウォレットへ転送されます。</span>
                      <span><b>Asset</b>でコインの種類を選択します。</span>
                      <span>［NEXT］ボタンをクリックします。</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s2.png" alt="Auto Transfer S1"/>
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>次にAuto Transfer機能が作動した際のコインの転送先ウォレット（Destination Wallet）を設定します。</span>
                      <span>同じアカウント内のウォレットを設定する場合は「Select destination from your wallets」から選択します。</span>
                      <span>別のアカウント内にあるウォレットを設定する場合は「Enter the destination」のフィールドにウォレットアドレスを直接入力してください。</span>
                      <span>入力したウォレットアドレスを確認して［NEXT］ボタンをクリックします。</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s3.png" alt="Auto Transfer S3"/>
                    </div>
                    <div className="text highlight">
                      <span>注意</span>
                      <span>Destination Walletには、コイン受信の際にTagの指定が必要のないウォレットを設定してください。例えばTagの指定が必要な取引所のウォレットアドレス等をDestination Walletに設定した場合、Auto Transferの転送処理自体は実行されますが、受け取り側で不明な着金となる可能性がありますのでくれぐれもご注意ください。</span>
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>次の画面では設定したAuto Transfer機能の流れが図で確認できます。</span>
                      <span>確認して［NEXT］ボタンをクリックします。</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s4.png" alt="Auto Transfer S1"/>
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>最終確認画面が表示されますので、確認して［CONFIRM］ボタンをクリックします。</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s5.png" alt="Auto Transfer S1"/>
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>OPパスワードとGoogle二段階認証を入力して完了です。</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s6.png" alt="Auto Transfer S1"/>
                    </div>
                  </li>
                  <li>
                    <div className="text">
                      <span>Auto Transferの設定情報は各ウォレットごとに確認することができます。</span>
                    </div>
                    <div className="img">
                      <img src="/images/setup-auto-transfer-s7.png" alt="Auto Transfer S1"/>
                    </div>
                  </li>
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default AutoTransferJa;



// WEBPACK FOOTER //
// ./src/containers/auto-transfer-ja.jsx